import React, { useEffect } from "react";
import { api_paths } from "../../config/api.paths";
import API from "../../config/axios";
import { useDispatch } from "react-redux";
import { SET_USER } from "../../redux/user/index";

const AppDataLoader = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("GSTB_token");
  const fetchUser = async () => {
    try {
      const response = await API.get(api_paths.member.GET_USER);

      if (response.data?.payload?.result) {
        dispatch(SET_USER(response.data.payload.result));
      }
    } catch (error) {
      console.error("Failed to fetch user:", error);
    }
  };

  useEffect(() => {
    if (token) {
      fetchUser();
    }
    // eslint-disable-next-line
  }, []);
  return <div></div>;
};

export default AppDataLoader;
